export const enum PermissionShortName {
  // System-scope permissions (global)
  ManageUsers = 'u:m',
  ManageTrackingUnits = 'tu:m',
  CreateMissions = 'm:c',
  SystemConfig = 's:c',
  MissionEligible = 'm:e',
  // Mission-scope permissions (per-mission)
  ManageMission = 'm:m',
  ViewMission = 'm:v',
}

export const enum TranslationKey {
  insufficientPermissions = 'Insufficient permissions',
  settingsHaveBeenSavedSuccessfully = 'Settings have been saved successfully',
  theRoleDoesNotExist = 'The role does not exist',
  thePermissionHasBeenAddedToTheRole = 'The permission has been added to the role',
  thePermissionHasBeenRemovedFromTheRole = 'The permission has been removed from the role',
  theRoleHasBeenDeleted = 'The role has been deleted',
  theRoleHasBeenUpdated = 'The role has been updated',
  invalidRoleName = 'Please enter a valid role name',
  settings = 'Settings',
  configureVariousSystemSettings = 'Configure various system settings',
  database = 'Database',
  databaseInformation = 'Database information',
  notAuthenticated = 'Not authenticated',
  theUserHasBeenUnassignedFromTheDevice = 'The user has been unassigned from the device',
  theUserHasBeenAddedtoTheDevice = 'The user has been added to the device',
  trackingUnitCreated = 'Tracking Unit created successfully',
  trackingUnitUpdated = 'Tracking Unit updated successfully',
  cantUpdateTrackingUnit = `Couldn't update the Tracking Unit`,
  administrator = 'Administrator',
  normalUser = 'Normal user',
  youDontHaveAccessToThisJob = `You don't have access to this mission`,
  speed = 'Speed',
  latitude = 'Latitude',
  longitude = 'Longitude',
  course = 'Course',
  theDeviceHasBeenUnassignedFromTheVehicle = 'The Tracking Unit has been unassigned from the vehicle',
  theDeviceHasBeenAddedToTheVehicle = 'The Tracking Unit has been added to the vehicle',
  theVehicleHasBeenAddedToTheJob = 'The vehicle has been added to the mission',
  theJobHasBeenUpdated = 'The mission has been updated',
  theJobHasBeenArchived = 'The mission has been archived successfully',
  theJobHasBeenDeleted = 'The mission has been deleted successfully',
  failedToDeleteMissionWithError = 'Error: Failed to delete mission',
  deleteMissionConfirm = 'deleteMissionConfirm',
  deleteMissionWarning = 'deleteMissionWarning',
  archiveRestoreSuccess = 'archiveRestoreSuccess',
  archiveRestoreFailed = 'archiveRestoreFailed',
  archiveRestoreAlreadyExists = 'archiveRestoreAlreadyExists',
  archiveDownloadSuccess = 'archiveDownloadSuccess',
  archiveDownloadFailed = 'archiveDownloadFailed',
  archiveDeleteSuccess = 'archiveDeleteSuccess',
  archiveDeleteFailed = 'archiveDeleteFailed',
  fileUploadSuccess = 'fileUploadSuccess',
  fileUploadFailed = 'fileUploadFailed',
  encryptionKeysSavedTrackingServerNotNotified = 'encryptionKeysSavedTrackingServerNotNotified',
  encryptionKeysDuplicateKeyId = 'encryptionKeysDuplicateKeyId',
  deleteArchiveConfirm = 'deleteArchiveConfirm',
  theJobWasNotFoundOrAccessIsDenied = 'The mission was not found or access is denied',
  jobNameExist = 'Mission name already exist',
  system = 'System',
  job = 'Mission',
  theRoleHasBeenCreated = 'The role has been created',
  theRoleHasBeenAddedToTheUser = 'The role has been added to the user',
  theRoleHasBeenRemovedFromTheUser = 'The role has been removed from the user',
  theUserHasBeenCreated  = 'The user has been created',
  theUserHasBeenUpdated = 'The user has been updated',
  theUserHasBeenDeactivated = 'The user has been deactivated',
  theUserHasBeenActivated = 'The user has been activated',
  passwordRequirements = 'Password requirements',
  theFollowingPasswordRequirementsAreNotMet = 'The following password requirements are not met',
  minimumLength = 'Minimum length',
  atLeastOneDigit = 'At least one digit',
  atLeastOneLowercaseLetter = 'At least one lowercase letter',
  atLeastOneUppercaseLetter = 'At least one uppercase letter',
  atLeastOneSpecialCharacter = 'At least one special character',
  byVehicle = 'By vehicle',
  byDevice = 'By Tracking Unit',
  liveAndLogPositions = 'Live and log positions',
  livePositions = 'Live positions',
  logPositions = 'Log positions',
  routeSection = 'Route section',
  daySection = 'Day section',
  allPositions = 'All positions',
  saved = 'Saved',
  cannotSaveDeviceAssignmentCheckForDateOverlaps = 'Cannot save Tracking Unit assignment. Check for date overlaps.',
  invalidDateRange = 'Invalid date range',
  missionStartDateInPast = 'Mission start date cannot be in the past',
  deviceAssignmentOutsideMissionPeriod = 'The Tracking Unit assignment must fall within the mission period',
  assignmentHasDataCannotDeleteLine1 = 'Data exists for this Tracking Unit in the assignment period, so it cannot be deleted.',
  assignmentHasDataCannotDeleteLine2 = 'To stop using it, change the To date instead.',
  missionManagerAdded = 'Mission Manager added',
  trackingUnitAssignmentAdded = 'Tracking Unit assignment added',
  trackingUnitAssignmentUpdated = 'Tracking Unit assignment updated',
  trackingUnitAssignmentRemoved = 'Tracking Unit assignment removed',
  failed = 'Failed',
  encryption = 'Encryption',
  encryptionInformation = 'Configure encrypted communication with Tracking Units',
  loggerUsedStorageLimitExceeded = 'Logger used storage limit exceeded',
  enteringGeoZone = 'Entering geo zone',
  leavingGeoZone = 'Leaving geo zone',
  enteringGSMGeoZone = 'Entering GSM geo zone',
  leavingGSMGeoZone = 'Leaving GSM geo zone',
  digitalInputOn = 'Digital input on',
  digitalInputOff = 'Digital input off',
  digitalInputChange = 'Digital input change',
  analogInputChange = 'Analog input change',
  enteringTimeRange = 'Entering time range',
  leavingTimeRange = 'Leaving time range',
  powerConsumptionMoreThanTriggerLevel = 'Power consumption more than trigger level',
  speedMoreThanTriggerLevel = 'Speed more than trigger level',
  speedLessThanTriggerLevel = 'Speed less than trigger level',
  gpsReceivingQualityChange = 'GPS receiving quality change',
  timer = 'Timer',
  realTime = 'Real time',
  temperatureMoreThanTriggerLevel = 'Temperature more than trigger level',
  temperatureLessThanTriggerLevel = 'Temperature less than trigger level',
  theVehicleHasBeenUpdated = 'The vehicle has been updated',
  phoneNumberRequired = 'Phone number is required',
  invalidPhoneNumber = 'Please enter a valid phone number',
  invalidEmail = 'Please enter a valid email address',
  firstNameRequired = 'First name is required',
  lastNameRequired = 'Last name is required',
  usernameRequired = 'Username is required',
  atLeastOneRoleRequired = 'At least one role is required',
  theUserProfileHasBeenUpdated = 'User profile updated succefully',
  invalidUserProfileSettings = 'Invalid user profile settings received',
  alarmTypeAlreadyExists = 'Alarm type already exists',
  onStandStill = 'On standstill',
  never = 'Never',
  always = 'Always',
  onEnteringSleep = 'On entering sleep mode',
  onLeaveSleep = 'On leaving sleep mode',
  onMotion = 'On motion',
  onMobileNwAttach = 'On mobile network attach',
  evtOnMobileNetworkDetach = 'On mobile network detach',
  multipleDigitalInputOn = 'On multiple digital inputs on',
  multipleDigitalInputOff = 'On multiple digital inputs off',
  multipleDigitalInputChange = 'On multiple digital inputs change',
  onIPConnection = 'On IP connection',
  onIPDisconnection = 'On IP disconnection',
  onCSDConnection = 'On CSD connection',
  onCSDDisconnection = 'On CSD disconnection',
  OnVoxActive = 'On vox active',
  onVoxPassive = 'On vox passive',
  onPowerUp = 'On power up',
  onAudioConnection = 'On audio connection',
  onAudioDisconnection = 'On audio disconnection',
  anyEvent = 'Any event',
  userProfileUpdationFailed = 'Failed to update user profile settings.',
  alarmUpdateFailed = 'Failed to update alarm notification settings.'
}

export const enum RouteParameterName {
  id = 'id'
}

export const enum OrderDirection {
  ascending = 0,
  descending = 1
}

export const enum StorageKey {
  authResponse = 'authResponse',
  language = 'language',
  appearanceMode = 'appearanceMode'
}

export const enum SpecialRole {
  systemManager = 'f49ee72d-d8bc-45b7-9c09-bf54e232f111',
  missionManager = '66ca2804-9cf5-498b-82ab-552d9396b8be',
  missionViewer = 'd3713591-e6ff-461e-acb8-25dd311afd8e'
}

export const enum AppearanceMode {
  dark = 'dark',
  light = 'light'
}

export enum DownloadFormat {
  kml = 'kml',
  csv = 'csv'
}
